import { proxy } from 'valtio'

export const searchQueryState = proxy<{ query: string }>({ query: '' })
export const setSearchQuery = (query: string) => {
  searchQueryState.query = query
}
export const resetSearchQuery = () => {
  searchQueryState.query = ''
}

export const searchQueryHitsCount = proxy<{value: Record<string, boolean>}>({value: {}})
export const resetHitsCount = () => {
  searchQueryHitsCount.value = {}
}

// export const unsub1 = devtools(searchQueryState, { name: 'searchQueryState', enabled: true })
// export const unsub2 = devtools(searchQueryHitsCount, { name: 'searchQueryHitsCount', enabled: true })
